import { Link } from 'react-router';
import { t } from '@/i18n';
import { useDocumentTitle } from '@/lib/use-document-title';
import { CenterCard } from './components/primitives';

export function NotFoundPage() {
  useDocumentTitle(t('titles.notFound'));
  return (
    <CenterCard title={t('notFound.title')}>
      <p className="mb-4 font-bold">{t('notFound.text')}</p>
      <Link
        to="/"
        className="font-extrabold underline max-sm:inline-flex max-sm:min-h-10 max-sm:items-center"
      >
        {t('notFound.home')}
      </Link>
    </CenterCard>
  );
}

export default NotFoundPage;
